<!-- 面试相关的 -->
<template>
  <div class="project-interview">
    <!-- banner -->
    <div class="project-interview-banner">
      <div class="banner-container">
        <h1>面试相关</h1>
        <p>请先填写面试信息，并联系CD，待确认后，即可预约导师进行模拟面试</p>
        <div class="banner-btn">
          <Button @click="infoHandle" v-if="isallowedit">面试信息</Button>
          <Button class="btn-exp"
                  @click="expHandle" v-if="isallowedit">面试经历</Button>
          <!-- disabled=true -->
          <Button class="btn-app"
                  @click="mentorHandle"
                  :disabled="!projectDetail.jointId || interviewData.interviewAudit !== 'PASS'" v-if="isallowedit">预约导师</Button>
        </div>
      </div>
    </div>
    <!-- 预约记录 -->
    <div>
      <interview-record></interview-record>
    </div>
    <!-- 面试信息 -->
    <interview-info ref="interviewInfo"
                    :interviewData="interviewData"
                    @on-success="getProjectInterviewDetail"></interview-info>
  </div>
</template>

<script>
// api
import { getProjectInterviewDetail } from '@/api/project'
// components
import InterviewInfo from './components/interview-info'
import InterviewRecord from './components/interview-record'
import { mapState } from 'vuex'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'project-interview',
  mixins: [isAllowEdit],
  components: {
    InterviewInfo,
    InterviewRecord
  },
  data () {
    return {
      programId: this.$route.params.id,
      interviewData: {}
    }
  },
  computed: {
    ...mapState({
      projectDetail (state) {
        return state.project.projectDetail
      }
    })
  },
  mounted () {
    this.getProjectInterviewDetail()
  },
  methods: {
    // 获取面试信息
    getProjectInterviewDetail () {
      getProjectInterviewDetail({
        id: this.programId
      }).then(res => {
        this.interviewData = res.data.model
        console.log(res)
      })
    },
    // 面试信息
    infoHandle () {
      this.$refs['interviewInfo'].showHandle()
    },
    // 面试经历
    expHandle () {
      this.$router.push({
        name: 'project-interview-exp'
      })
    },
    // 申请导师
    mentorHandle () {
      this.$router.push({
        name: 'project-interview-mentor'
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
